var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 35,
    width: 35,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 9.333h-1.283C29.633 6.65 27.3 4.667 24.5 4.667h-2.333V3.5c0-1.983-1.517-3.5-3.5-3.5h-2.334c-1.983 0-3.5 1.517-3.5 3.5v1.167H10.5c-2.8 0-5.133 1.983-5.717 4.666H3.5c-1.983 0-3.5 1.517-3.5 3.5 0 1.984 1.517 3.5 3.5 3.5h1.167v12.834C4.667 32.433 7.233 35 10.5 35h14c3.267 0 5.833-2.567 5.833-5.833V16.333H31.5c1.983 0 3.5-1.516 3.5-3.5 0-1.983-1.517-3.5-3.5-3.5zM15.167 3.5c0-.7.466-1.167 1.166-1.167h2.334c.7 0 1.166.467 1.166 1.167v1.167h-4.666zM10.5 7h14c1.517 0 2.8.933 3.267 2.333H7.233C7.7 7.933 8.983 7 10.5 7zm-7 7c-.7 0-1.167-.467-1.167-1.167S2.8 11.667 3.5 11.667h1.167V14zM28 29.167c0 1.983-1.517 3.5-3.5 3.5h-14c-1.983 0-3.5-1.517-3.5-3.5v-17.5h21zM31.5 14h-1.167v-2.333H31.5c.7 0 1.167.466 1.167 1.166S32.2 14 31.5 14z",
    fill: "#444"
  })));
}

export default __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/promo-banners/less-prep/boil-da952e2149cec92fd2a93b23027e99d4.svg";
export { SvgBoil as Component };